/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { useArrowNavigation } from '../use-arrow-navigation/use-arrow-navigation';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export type { TUseArrowNavigationArgs } from '../use-arrow-navigation/use-arrow-navigation';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { isAtCurrentMenuLevel } from '../use-arrow-navigation/is-at-current-menu-level';
